import keyMirror from "key-mirror";

export default keyMirror({
  LOGIN_TO_GATEWAY: undefined,
  INSERT_TAP_SWIPE_CARD: undefined,
  TAP_SWIPE_CARD: undefined,
  WAITING_FOR_SWIPE: undefined,
  SWIPE_CARD: undefined,
  SWIPE_DETECTED: undefined,
  TAP_DETECTED: undefined,
  CARD_INSERTED: undefined,
  REMOVE_CARD: undefined,
  APPLICATION_SELECTION_COMPLETED: undefined,
  GETTING_ONLINE_AUTHORIZATION: undefined,
  UPDATING_TRANSACTION: undefined,
  GETTING_CARD_VERIFICATION: undefined,
  RESWIPE_CARD: undefined,
  REINSERT_CARD: undefined,
  SWIPE_NOT_ALLOWED: undefined,
  CHIP_CARD_SWIPE_FAILED: undefined,
  INSERT_SWIPE_CARD: undefined,
  CONTACTLESS_INTERFACE_FAILED: undefined,
  CARD_REMOVED: undefined,
  UNKNOWN_RESPONSE: undefined,
});
